// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PaymentsMade from '../components/PaymentsMade/PaymentsMade';
import { actions as PaymentsAction } from '../duck';
import { actions as AlertActions } from '../../alert/duck';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState){
  return {
    isFetchingPaymentsMade: state.payments.isFetchingPaymentsMade,
    paymentsMade: state.payments.paymentsMade,
    canAsk: state.payments.paymentsMadePageCanAsk,
    fetchPaymentsMadeError: state.payments.fetchPaymentsMadeError,
  };
}

function mapDispatchToProps(dispatch: Function){
  return bindActionCreators({ ...PaymentsAction, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentsMade);



// WEBPACK FOOTER //
// ./src/modules/payments/containers/PaymentsMadeContainer.js